import { render } from "./Location.vue?vue&type=template&id=4d947fa9&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4d947fa9"

export default script